<template>
  <v-card :class="`problem-card-back card${index + 1}`" height="300px">
    <v-card-text class="text-center card-info d-flex align-center justify-center">
      <div>
        <v-col class="card-header font-weight-bold text-uppercase my-3">
          {{value.title}}
        </v-col>
        <v-col
          v-if="value.text"
          class="card-content font-weight-regular "
        >
          {{value.text}}
        </v-col>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ProblemCard",
  data() {
    return {}
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    index: {
      type: Number
    }
  }
}
</script>

<style scoped>

.problem-card-back {
  background: rgba(33,33,33,0.7);
  /*margin: auto;*/
  border: 2px solid #eeeeee;
}

.card-info {
  background: rgba(255,255,255,0.6);
  height: inherit;
  color: #030303;

}

.card-header {
  color: #030303;

}
.card-content {
  background: rgba(255,255,255,0.6);
  border: 2px solid #343434;
  color: #030303;

}





.card1 {
  background-image: url('../../public/pictures/1.jpg');
  background-position: center center;
  background-size: cover;
}

.card2 {
  background-image: url('../../public/pictures/2.jpg');
  background-position: center center;
  background-size: cover;

}

.card3 {
  background-image: url('../../public/pictures/3.jpg');
  background-position: center center;
  background-size: cover;

}

.card4 {
  background-image: url('../../public/pictures/4.jpg');
  background-position: center center;
  background-size: cover;

}

.card5 {
  background-image: url('../../public/pictures/5.jpg');
  background-position: center center;
  background-size: cover;

}

.card6 {
  background-image: url('../../public/pictures/6.jpg');
  background-position: center center;
  background-size: cover;

}

.card7 {
  background-image: url('../../public/pictures/7.jpg');
  background-position: center center;
  background-size: cover;

}

.card8 {
  background-image: url('../../public/pictures/8.jpg');
  background-position: center center;
  background-size: cover;

}

.card9 {
  background-image: url('../../public/pictures/9.jpg');
  background-position: center center;
  background-size: cover;

}

.card10 {
  background-image: url('../../public/pictures/10.jpg');
  background-position: center center;
  background-size: cover;

}

.card11 {
  background-image: url('../../public/pictures/11.jpg');
  background-position: center center;
  background-size: cover;

}

.card12 {
  background-image: url('../../public/pictures/12.jpg');
  background-position: center center;
  background-size: cover;
}



.card100 {
  background-image: url('../../public/pictures/record/offline.jpg');
  background-position: center center;
}

.card101{
  background-image: url('../../public/pictures/record/online.jpg');
  background-position: center center;
  background-size: cover;
}

</style>